module.exports = __webpack_public_path__ + "img/endorseIdentity.0748c2df.jpg";